import keyMirror from "key-mirror";

export const DECISIONING_DASHBOARD_ACTIONS = keyMirror({
    FETCH_DECISIONING_DASHBOARD_COLUMNS: null,
    FETCHED_DECISIONING_DASHBOARD_COLUMNS: null,
    FAILED_FETCH_DECISIONING_DASHBOARD_COLUMNS: null,

    FETCH_DECISIONING_DASHBOARD_ROWS: null,
    FETCHED_DECISIONING_DASHBOARD_ROWS: null,
    FAILED_FETCH_DECISIONING_DASHBOARD_ROWS: null,
    
    FETCH_DECISIONING_DASHBOARD_PROCEED: null,
    FETCHED_DECISIONING_DASHBOARD_PROCEED: null,
    FAILED_FETCH_DECISIONING_DASHBOARD_PROCEED: null,

    FETCH_DECISIONING_DASHBOARD_REFER: null,
    FETCHED_DECISIONING_DASHBOARD_REFER: null,
    FAILED_FETCH_DECISIONING_DASHBOARD_REFER: null,

    FETCH_DECISIONING_DASHBOARD_SANCTION: null,
    FETCHED_DECISIONING_DASHBOARD_SANCTION: null,
    FAILED_FETCH_DECISIONING_DASHBOARD_SANCTION: null,
});



